import * as React from 'react';
import { RouteComponentProps } from 'react-router';
import { connect } from 'react-redux';
import { EnhancedListViewContainer } from 'modules/pub-docs/containers/ListViewContainer';
import { EnhancedTreeViewContainer } from 'modules/pub-docs/containers/TreeViewContainer';
import { TApplicationState } from 'modules/pub-docs/store';

type TMainViewProps = {
  siteKey: string;
  documentId?: string;
  view?: 'list' | 'tree';
};

type Props = RouteComponentProps<TMainViewProps> & {
  siteName?: string;
};

// TODO: Remove MainView since the branching logic can be performed in Router instead.
const MainView: React.SFC<Props> = ({ match, history, siteName }) => {
  const { view, siteKey, documentId } = match.params;

  React.useEffect(() => {
    document.title = `Public Docs - ${siteName}`;
  }, [siteName]);

  return (
    <div className="pubDocsMainView">
      {view === 'list' && (
        <EnhancedListViewContainer siteKey={siteKey} documentId={documentId} history={history} />
      )}
      {view === 'tree' && (
        <EnhancedTreeViewContainer siteKey={siteKey} documentId={documentId} history={history} />
      )}
    </div>
  );
};

const mapStateToProps = (state: TApplicationState) => ({
  siteName: state.siteInfo.data.siteName,
});

export default connect(mapStateToProps)(MainView);
